var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtxCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d3c;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#fff;}.cls-4{fill:#a440f2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 60,
    y1: 142.84,
    x2: 452,
    y2: 369.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#221e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#302256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#482876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6931a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#923bda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a440f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38d6b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 256,
    cy: 256,
    r: 226.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 210.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.23,110.32V401.68H380.78V110.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "256.19 193.38 256.19 276.7 339.17 276.7 339.17 318.44 172.84 318.44 172.84 151.94 339.17 151.94 339.17 193.38 256.19 193.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 172.84,
    y: 360.89,
    width: 166.33,
    height: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtxCoin);
export default __webpack_public_path__ + "static/media/ctx-coin.e2ce1e1ae292e9d87f0d10250b0a7cc8.svg";
export { ForwardRef as ReactComponent };